import CourtDeadlineRule from "../../entities/courtDeadlineRule";

/**
 * CourtDeadlineRule actions
 *
 * Call order:
 *
 * COURTDEADLINERULE_SAVE_QUEUE:	adds the item to the save queue
 * --> COURTDEADLINERULE_SAVE:	modifies the state
 * --> COURTDEADLINERULE_SAVE_SUCCESS: if all went well
 * --> COURTDEADLINERULE_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail COURTDEADLINERULE_SAVE_QUEUE is during the call to COURTDEADLINERULE_SAVE,
 * as adding an item to the queue should never fail.
 *
 * OWA-1018: the reducer shows a queued save at COURTDEADLINERULE_SAVE_QUEUE, marked pending, and only that
 * save's own outcome settles the mark: COURTDEADLINERULE_SAVE_SUCCESS, COURTDEADLINERULE_SAVE_REVERT (refused, or
 * never queued), a refusal the queue never retries, or COURTDEADLINERULE_PENDING_CHECK (it left the queue).
 */

export const COURTDEADLINERULE_FETCH_ONE_QUEUE: any = 'COURTDEADLINERULE_FETCH_ONE_QUEUE';
export const COURTDEADLINERULE_FETCH_SUCCESS: any = 'COURTDEADLINERULE_FETCH_SUCCESS';
export const COURTDEADLINERULE_FETCH_FAILURE: any = 'COURTDEADLINERULE_FETCH_FAILURE';
export const COURTDEADLINERULE_FETCH_ONE_SUCCESS: any = 'COURTDEADLINERULE_FETCH_ONE_SUCCESS';
export const COURTDEADLINERULE_FETCH_ONE_FAILURE: any = 'COURTDEADLINERULE_FETCH_ONE_FAILURE';

export const COURTDEADLINERULE_SAVE: any = 'COURTDEADLINERULE_SAVE';
export const COURTDEADLINERULE_SAVE_QUEUE: any = 'COURTDEADLINERULE_SAVE_QUEUE';
export const COURTDEADLINERULE_SAVE_SUCCESS: any = 'COURTDEADLINERULE_SAVE_SUCCESS';
export const COURTDEADLINERULE_SAVE_FAILURE: any = 'COURTDEADLINERULE_SAVE_FAILURE';

export const COURTDEADLINERULE_SAVE_MANY: any = 'COURTDEADLINERULE_SAVE_MANY';
export const COURTDEADLINERULE_SAVE_MANY_QUEUE: any = 'COURTDEADLINERULE_SAVE_MANY_QUEUE';
export const COURTDEADLINERULE_SAVE_MANY_SUCCESS: any = 'COURTDEADLINERULE_SAVE_MANY_SUCCESS';
export const COURTDEADLINERULE_SAVE_MANY_FAILURE: any = 'COURTDEADLINERULE_SAVE_MANY_FAILURE';

export const COURTDEADLINERULE_REMOVE: any = 'COURTDEADLINERULE_REMOVE';
export const COURTDEADLINERULE_REMOVE_QUEUE: any = 'COURTDEADLINERULE_REMOVE_QUEUE';
export const COURTDEADLINERULE_REMOVE_SUCCESS: any = 'COURTDEADLINERULE_REMOVE_SUCCESS';
export const COURTDEADLINERULE_REMOVE_FAILURE: any = 'COURTDEADLINERULE_REMOVE_FAILURE';

export const COURTDEADLINERULE_RESTORE: any = 'COURTDEADLINERULE_RESTORE';
export const COURTDEADLINERULE_RESTORE_QUEUE: any = 'COURTDEADLINERULE_RESTORE_QUEUE';
export const COURTDEADLINERULE_RESTORE_SUCCESS: any = 'COURTDEADLINERULE_RESTORE_SUCCESS';
export const COURTDEADLINERULE_RESTORE_FAILURE: any = 'COURTDEADLINERULE_RESTORE_FAILURE';

export const COURTDEADLINERULE_RESTORE_MANY: any = 'COURTDEADLINERULE_RESTORE_MANY';
export const COURTDEADLINERULE_REMOVE_MANY: any = 'COURTDEADLINERULE_REMOVE_MANY';

// OWA-1018: settle this tab's pending save of a record
export const COURTDEADLINERULE_SAVE_REVERT: any = 'COURTDEADLINERULE_SAVE_REVERT';
export const COURTDEADLINERULE_PENDING_CHECK: any = 'COURTDEADLINERULE_PENDING_CHECK';

/* Fetch actions */
export const fetchCourtDeadlineRuleSuccess = (courtDeadlineRules: CourtDeadlineRule[], partial: boolean, lastFetch: number) => ({type: COURTDEADLINERULE_FETCH_SUCCESS, courtDeadlineRules, partial, lastFetch});
export const fetchCourtDeadlineRuleFailure = (err: any) => {
		console.error('CourtDeadlineRuleAction: fetchCourtDeadlineRuleFailure', err);
		return {type: COURTDEADLINERULE_FETCH_FAILURE, err};
};
export const fetchOneCourtDeadlineRuleQueue = (courtDeadlineRuleId: string, sentAddedOn?: number) => ({type: COURTDEADLINERULE_FETCH_ONE_QUEUE, courtDeadlineRuleId, sentAddedOn});
export const fetchOneCourtDeadlineRuleSuccess = (courtDeadlineRule: CourtDeadlineRule | null, sentAddedOn?: number, courtDeadlineRuleId: string = courtDeadlineRule?.id) => ({type: COURTDEADLINERULE_FETCH_ONE_SUCCESS, courtDeadlineRuleId, courtDeadlineRule, sentAddedOn});
export const fetchOneCourtDeadlineRuleFailure = (id: string, err: any) => {
		console.error('CourtDeadlineRuleAction: fetchOneCourtDeadlineRuleFailure', err);
		return {type: COURTDEADLINERULE_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveCourtDeadlineRule = (courtDeadlineRule: CourtDeadlineRule) => {
    // console.debug('⮂ COURTDEADLINERULE_SAVE action', courtDeadlineRule?.id);
    return {type: COURTDEADLINERULE_SAVE, courtDeadlineRule};
}
export const saveCourtDeadlineRuleQueue = (courtDeadlineRule: CourtDeadlineRule, onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ COURTDEADLINERULE_SAVE_QUEUE action', courtDeadlineRule?.id);
    return {type: COURTDEADLINERULE_SAVE_QUEUE, courtDeadlineRule, onQueued};
}
export const saveCourtDeadlineRuleSuccess = (courtDeadlineRule: CourtDeadlineRule, sentAddedOn?: number) => {
    // console.debug('⮂ COURTDEADLINERULE_SAVE_SUCCESS action', courtDeadlineRule?.id);
    return {type: COURTDEADLINERULE_SAVE_SUCCESS, courtDeadlineRule, sentAddedOn};
}
export const saveCourtDeadlineRuleFailure = (courtDeadlineRule: CourtDeadlineRule, status: number, message: string) => {
    console.warn(`⮂ COURTDEADLINERULE_SAVE_FAILURE error saving courtDeadlineRule: HTTP ${status}: ${message}`, courtDeadlineRule?.id);
    return {type: COURTDEADLINERULE_SAVE_FAILURE, courtDeadlineRule, status, message};
};

/* SaveMany actions */
export const saveManyCourtDeadlineRules = (courtDeadlineRules: CourtDeadlineRule[]) => {
    // console.debug('⮂ COURTDEADLINERULE_SAVE_MANY action', courtDeadlineRules?.map(courtDeadlineRule => courtDeadlineRule?.id).join(','));
    return {type: COURTDEADLINERULE_SAVE_MANY, courtDeadlineRules};
}
export const saveManyCourtDeadlineRulesQueue = (courtDeadlineRules: CourtDeadlineRule[], onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ COURTDEADLINERULE_SAVE_MANY_QUEUE action', courtDeadlineRules?.map(courtDeadlineRule => courtDeadlineRule.id).join(','));
    return {type: COURTDEADLINERULE_SAVE_MANY_QUEUE, courtDeadlineRules, onQueued};
}

/** `sentAddedOns`: the queue key each answer acknowledges, aligned with `courtDeadlineRules` (OWA-1018) */
export const saveManyCourtDeadlineRulesSuccess = (courtDeadlineRules: CourtDeadlineRule[], sentAddedOns?: (number | undefined)[]) => {
    // console.debug('⮂ COURTDEADLINERULE_SAVE_MANY_SUCCESS action', courtDeadlineRules?.map(courtDeadlineRule => courtDeadlineRule.id).join(','));
    return {type: COURTDEADLINERULE_SAVE_MANY_SUCCESS, courtDeadlineRules, sentAddedOns};
}
export const saveManyCourtDeadlineRulesFailure = (courtDeadlineRules: CourtDeadlineRule[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_COURTDEADLINERULES_FAILURE Error saving courtDeadlineRules: HTTP ${status}: ${message}`, courtDeadlineRules?.map(courtDeadlineRule => courtDeadlineRule.id).join(','));
		return {type: COURTDEADLINERULE_SAVE_MANY_FAILURE, courtDeadlineRules, status, message};
};

/* Remove actions */
export const removeCourtDeadlineRule = (courtDeadlineRule: CourtDeadlineRule) => ({ type: COURTDEADLINERULE_REMOVE, courtDeadlineRule });
export const removeCourtDeadlineRuleQueue = (courtDeadlineRule: CourtDeadlineRule) => ({ type: COURTDEADLINERULE_REMOVE_QUEUE, courtDeadlineRule });
export const removeCourtDeadlineRuleSuccess = (courtDeadlineRule: CourtDeadlineRule) => ({ type: COURTDEADLINERULE_REMOVE_SUCCESS, courtDeadlineRule });
export const removeCourtDeadlineRuleFailure = (courtDeadlineRule: CourtDeadlineRule, status: number, message: string) => {
	console.error(`Redux: removeCourtDeadlineRuleFailure Error removing courtDeadlineRule: HTTP ${status}: ${message}`);
	return ({ type: COURTDEADLINERULE_REMOVE_FAILURE, courtDeadlineRule, status, message });
};

/* Restore actions */
export const restoreCourtDeadlineRule = (courtDeadlineRule: CourtDeadlineRule) => ({ type: COURTDEADLINERULE_RESTORE, courtDeadlineRule });
export const restoreCourtDeadlineRuleQueue = (courtDeadlineRule: CourtDeadlineRule) => ({ type: COURTDEADLINERULE_RESTORE_QUEUE, courtDeadlineRule });
export const restoreCourtDeadlineRuleSuccess = (courtDeadlineRule: CourtDeadlineRule, sentAddedOn?: number) => ({ type: COURTDEADLINERULE_RESTORE_SUCCESS, courtDeadlineRule, sentAddedOn });
export const restoreCourtDeadlineRuleFailure = (courtDeadlineRule: CourtDeadlineRule, status: number, message: string) => {
	console.error(`Redux: restoreCourtDeadlineRuleFailure Error restoring courtDeadlineRule: HTTP ${status}: ${message}`);
	return ({ type: COURTDEADLINERULE_RESTORE_FAILURE, courtDeadlineRule, status, message });
};

/* RestoreMany actions */
export const restoreManyCourtDeadlineRules = (courtDeadlineRules: CourtDeadlineRule[]) => ({ type: COURTDEADLINERULE_RESTORE_MANY, courtDeadlineRules });

/* RemoveMany actions */
export const removeManyCourtDeadlineRules = (courtDeadlineRules: CourtDeadlineRule[]) => ({ type: COURTDEADLINERULE_REMOVE_MANY, courtDeadlineRules });

/* Pending save actions (OWA-1018) */
/**
 * The save `courtDeadlineRule` (queue key `sentAddedOn`, default its addedOn) will not be accepted: it was
 * refused, or never reached the queue. Its row returns to the latest accepted version, or to
 * `current` (the record as the server holds it) when that is newer; `keep` leaves the row shown.
 */
export const revertCourtDeadlineRuleSave = (courtDeadlineRule: CourtDeadlineRule, options: {sentAddedOn?: number, current?: CourtDeadlineRule | null, keep?: boolean} = {}) =>
    ({type: COURTDEADLINERULE_SAVE_REVERT, courtDeadlineRule, ...options});
/** processQueue read the shared queue at `readAt` (performance.now()): the live and the permanently refused queue keys */
export const checkCourtDeadlineRulePendingSaves = (live: number[], refused: number[], readAt: number) =>
    ({type: COURTDEADLINERULE_PENDING_CHECK, live, refused, readAt});